import manifestJson from "../../reset-manifest.json"

export type ResetManifest = {
  schemaVersion: number
  application: string
  fixtureVersion: string
  schedule: {
    cron: string
    timeZone: string
    utcOffset: string
    localTime: string
  }
  storage: {
    kv: {
      binding: string
      currentKeyPattern: string
      canonicalSentinelPattern: string
      cleanupPrefixPattern: string
      sessionTtlSeconds: number
      authoritativeReset: string
      physicalCleanup: string
    }
    durableObject: {
      binding: string
      className: string
      contents: string
    }
    browser: {
      state: string
      invalidation: string
    }
    externalSystems: Array<string>
  }
  visitorDataRemoved: Array<string>
  canonicalDataRestored: {
    orders: number
    downloads: number
    sentinelOrderId: string
    sentinelDownloadId: string
    workflow: string
  }
  intentionallyPreserved: Array<string>
  ordering: Array<string>
  referentialIntegrity: string
  interruptedRunRecovery: string
  writeBehaviorDuringReset: string
  verificationCriteria: Array<string>
  rollbackOrRecovery: string
  productionActivation: string
}

export const RESET_MANIFEST = manifestJson as ResetManifest

export const RESET_COORDINATOR_NAME = "service-portal"
export const RESET_STATUS_PATH = "/api/demo-reset-status"
export const LOCAL_RESET_PATH = "/api/demo-reset-local"
export const LOCAL_RESET_HEADER = "x-service-portal-local-reset"
export const LOCAL_RESET_TOKEN = "service-portal-local-reset-v1"
export const OPERATOR_RESET_PATH = "/api/demo-reset-operator"
export const OPERATOR_RESET_SECRET = "DEMO_RESET_OPERATOR_SECRET"
export const OPERATOR_RESET_MIN_SECRET_BYTES = 32
export const RESET_QUEUE_NAME = "service-portal-demo-reset"
export const RESET_DLQ_NAME = "service-portal-demo-reset-dlq"
export const KV_PAGE_LIMIT = 64
export const WRITE_LEASE_TTL_MS = 30_000
export const RESET_OVERDUE_GRACE_MS = 2 * 60 * 60 * 1000
